import {
  AutocompleteInput,
  Datagrid,
  FunctionField,
  List,
  NumberField,
  ReferenceInput,
  SimpleList,
  TextField,
  TextInput,
  useStore,
} from "react-admin";
import CustomFilter from "features/CustomFilter";
import useSemesterFilter from "features/filters/useSemesterFilter";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import ClassesForMakeUpExpanded from "./ClassesForMakeUpExpanded";
import ClassesForMakeUpMobileExpanded from "./ClassesForMakeUpMobileExpanded";
import { tenants } from "utils/tenants";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";

const STORE_KEY = "makeUps.filters";

const ListMakeUps = () => {
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const semester = useSemesterFilter({ filters, sessionField: "sessionType" });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  const listFilter = [
    <TextInput
      source="facultyNumber"
      label="Факултетен номер"
      alwaysOn
      style={{ width: 150 }}
    />,
    <ReferenceInput
      source="disciplineId"
      reference={administrationRequests.getDisciplinesSelect()}
      alwaysOn
    >
      <AutocompleteInput
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        optionText="name"
        label="Дисциплина"
        fullWidth
        style={{ width: 500 }}
      />
    </ReferenceInput>,
  ];
  return (
    <>
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={semester.fields}
        buttonLabel="Покажи"
        buttonDisabled={!semester.isComplete}
        buttonOnClick={() => handleSearch(semester.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              {`Въведи филтри за ${settings.tenant !== tenants.MGU ? "отработване на упражнения" : "извиняване на отсъствия"}.`}
            </Typography>
          </Box>
        </Paper>
      ) : (
        <List
          title={settings.tenant !== tenants.MGU ? "Отработване на упражнения" : "Извиняване на отсъствия"}
          exporter={false}
          filter={filters}
          filters={listFilter}
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => (
                <div>
                  <MobileListRow fields={[{ label: "Факултетен номер", value: record?.studentFacultyNumber }]} />
                  <MobileListRow
                    fields={[
                      { label: "Име", value: record?.studentFirstName },
                      { label: "Презиме", value: record?.studentSecondName ?? "-" },
                      { label: "Фамилия", value: record?.studentLastName },
                    ]}
                  />
                </div>
              )}
              secondaryText={record => (
                <>
                  <div>
                    <MobileListRow fields={[{ label: "Дисциплина", value: record?.disciplineName }]} />
                    <MobileListRow fields={[{ label: "Брой упражнения", value: record?.classesCount }]} />
                  </div>
                  <ClassesForMakeUpMobileExpanded record={record} />
                </>
              )}
            />
          ) : (
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
              expand={<ClassesForMakeUpExpanded />}
              expandSingle
            >
              <TextField
                source="studentFacultyNumber"
                label="Факултетен номер"
              />
              <FunctionField
                label="Име"
                render={rec =>
                  rec.studentSecondName
                    ? `${rec.studentFirstName} ${rec.studentSecondName} ${rec.studentLastName}`
                    : `${rec.studentFirstName} ${rec.studentLastName}`
                }
              />
              <TextField
                source="disciplineName"
                label="Дисциплина"
              />
              <TextField
                source="studyGroup"
                label="Учебна група"
                emptyText="-"
              />
              <NumberField
                source="classesCount"
                label="Брой упражнения"
                textAlign="left"
              />
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListMakeUps;
